<template>
<h1>CONTACT page is coming soon ...</h1>
<div>Thank you for your patience</div>
</template>

